import { render, staticRenderFns } from "./r-multi-tab-stage-dialog.vue?vue&type=template&id=6372cdf5&scoped=true"
import script from "./r-multi-tab-stage-dialog.vue?vue&type=script&lang=js"
export * from "./r-multi-tab-stage-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-multi-tab-stage-dialog.vue?vue&type=style&index=0&id=6372cdf5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372cdf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6372cdf5')) {
      api.createRecord('6372cdf5', component.options)
    } else {
      api.reload('6372cdf5', component.options)
    }
    module.hot.accept("./r-multi-tab-stage-dialog.vue?vue&type=template&id=6372cdf5&scoped=true", function () {
      api.rerender('6372cdf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-multi-tab/r-multi-tab-stage-dialog.vue"
export default component.exports